<script setup>
import Modal from './Modal.vue';
import { Upgrade } from '@components';
import { useTranslation } from '../composables/useTranslation';

const { t } = useTranslation();
const isLocked = ! formychat_admin_vars.is_premium;
</script>

<template>
	<div class="w-full p-2 sm:p-6 formychat relative">
		<div class="w-full full-screen bg-white pt-3 pb-6 sm:pt-8 sm:pb-14 px-3 sm:px-8 text-[14px] relative">
			<router-view />
			<Upgrade />
			<div v-if="isLocked" class="sm:absolute sm:bottom-3 sm:left-1/2 sm:-translate-x-1/2 text-xs text-gray-500 tracking-wide flex items-center justify-center text-center pt-6 gap-1"><a class="text-indigo-500 hover:text-indigo-400 transition font-medium" target="_blank" href="https://lnk.wppool.dev/xz3tUxG">{{ t('try_premium') }}</a></div>
		</div>
		<Modal />
	</div>
</template>

